import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components/native';
import Text from '../text';
import Colors from '../colors';
const colors = {
  default: {
    date: Colors.gray400,
    background: Colors.lightGray100
  },
  active: {
    date: Colors.advanceBlue400,
    background: Colors.white
  }
};
const StyledContainer = styled.Pressable`
  flex-direction: row;
  align-self: flex-start;
  width: 100%;
  background-color: ${props => colors[props.type].background};
  border: 1px solid transparent;
  border-bottom-color: ${Colors.lightGray300};
  padding: 16px 24px 18px 24px;
`;
const StyledPair = styled.View`
  flex: 1;
`;
const StyledText = styled.Text`
  max-width: 100%;
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
const StyledDate = styled.View`
  flex: 0 1 auto;
  align-self: center;
  padding-bottom: 10px;
`;
const StyledSpace = styled.View`
  height: ${props => props.height ? 3 : 0}px;
  width: ${props => props.width ? 11 : 0}px;
`;

const getDate = date => {
  const currentDate = NotificationRow.defaultProps.date;
  const currentYear = currentDate.getFullYear();
  const year = date.getFullYear();
  const oneDay = 86400000;
  const monthDayFormat = date.toLocaleDateString('en-US', {
    month: 'short',
    day: '2-digit'
  });
  const fullDateFormat = date.toLocaleDateString('en-GB', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  });
  currentDate.setHours(0, 0, 0, 0);
  date.setHours(0, 0, 0, 0);

  switch (true) {
    case currentDate % date === 0:
      return 'Today';

    case currentDate % date === oneDay:
      return 'Yesterday';

    case currentDate % date > oneDay && currentYear === year:
      return monthDayFormat;

    default:
      return fullDateFormat;
  }
};

export default function NotificationRow(props) {
  const type = Object.keys(colors).includes(props.type) ? props.type : NotificationRow.defaultProps.type;
  const weight = type === 'active' ? 'medium' : 'regular';
  const date = getDate(props.date);
  return /*#__PURE__*/React.createElement(StyledContainer, {
    type: type,
    onPress: () => props.onPress()
  }, /*#__PURE__*/React.createElement(StyledPair, null, /*#__PURE__*/React.createElement(Text.BodySmall, {
    align: "left",
    weight: "medium",
    color: Colors.gray600
  }, /*#__PURE__*/React.createElement(StyledText, null, props.title)), /*#__PURE__*/React.createElement(StyledSpace, {
    height: true
  }), /*#__PURE__*/React.createElement(Text.BodyExtraSmall, {
    align: "left",
    weight: "regular",
    color: Colors.gray300
  }, /*#__PURE__*/React.createElement(StyledText, null, props.children))), /*#__PURE__*/React.createElement(StyledSpace, {
    width: true
  }), /*#__PURE__*/React.createElement(StyledDate, null, /*#__PURE__*/React.createElement(Text.BodyExtraSmall, {
    align: "center",
    weight: weight,
    color: colors[type].date
  }, date)));
}
NotificationRow.defaultProps = {
  type: 'default',
  title: 'Title',
  date: new Date(),
  onPress: () => null,
  children: ''
};
NotificationRow.propTypes = {
  type: PropTypes.oneOf(Object.keys(colors)),
  title: PropTypes.string,
  date: PropTypes.instanceOf(Date),
  onPress: PropTypes.func,
  children: PropTypes.string
};
//# sourceMappingURL=index.js.map